import {SliderGallerySlideNavigation} from "@pg-design/slider-gallery-module";

import {AmplitudeViewPhotoNavigation} from "./track_amplitude_view_photo";

/**
 * Maps a `SliderGallery` slide change onto the `photo_navigation` value of the `view_photo` event.
 * The slider reports the navigation type only for its own interactions - the index comparison is
 * a fallback for slide changes triggered from the outside (e.g. an infinite-scroll wrap-around).
 */
export const getAmplitudeViewPhotoNavigation = (
    currentSlideIndex: number,
    nextSlideIndex: number,
    slideNavigation?: SliderGallerySlideNavigation
): AmplitudeViewPhotoNavigation => {
    switch (slideNavigation) {
        case SliderGallerySlideNavigation.SWIPE:
            return "swipe";
        case SliderGallerySlideNavigation.ARROW_NEXT:
            return "arrow_next";
        case SliderGallerySlideNavigation.ARROW_PREV:
            return "arrow_prev";
        default:
            return nextSlideIndex >= currentSlideIndex ? "arrow_next" : "arrow_prev";
    }
};
import {SliderGallerySlideNavigation} from "@pg-design/slider-gallery-module";

import {AmplitudeViewPhotoNavigation} from "./track_amplitude_view_photo";

/**
 * Maps a `SliderGallery` slide change onto the `photo_navigation` value of the `view_photo` event.
 * The slider reports the navigation type only for its own interactions - the index comparison is
 * a fallback for slide changes triggered from the outside (e.g. an infinite-scroll wrap-around).
 */
export const getAmplitudeViewPhotoNavigation = (
    currentSlideIndex: number,
    nextSlideIndex: number,
    slideNavigation?: SliderGallerySlideNavigation
): AmplitudeViewPhotoNavigation => {
    switch (slideNavigation) {
        case SliderGallerySlideNavigation.SWIPE:
            return "swipe";
        case SliderGallerySlideNavigation.ARROW_NEXT:
            return "arrow_next";
        case SliderGallerySlideNavigation.ARROW_PREV:
            return "arrow_prev";
        default:
            return nextSlideIndex >= currentSlideIndex ? "arrow_next" : "arrow_prev";
    }
};
